import { DsLibMainMenuSectionInterface } from '@sixense/ds-lib-main-menu';

export const DS_HOME_MENU: DsLibMainMenuSectionInterface = {
  title: 'menu.dashboard.home',
  icon: 'home',
  expandable: false,
  expanded: true,
  link: {
    disabled: false,
    url: 'projects/{id}/home',
  },
  links: [],
};
